module.exports = __webpack_public_path__ + "static/img/draw_a_billing.daebf46a.png";